import React, { useEffect, useState } from "react";

function BlogsPage() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedPost, setSelectedPost] = useState(null);

  // 👉 Replace with your WordPress site URL
  const WP_API = "https://wordpress.samis.com.sg/wp-json/wp/v2/posts";

  useEffect(function () {
    fetch(WP_API)
      .then(function (res) {
        console.log(res)
        return res.json();
      })
      .then(function (data) {
        setPosts(data);
        setLoading(false);
      })
      .catch(function (err) {
        console.error("Error fetching posts:", err);
        setLoading(false);
      });
  }, []);

  // function getImage(post) {
  //   if (
  //     post._embedded &&
  //     post._embedded["wp:featuredmedia"] &&
  //     post._embedded["wp:featuredmedia"][0]
  //   ) {
  //     return post._embedded["wp:featuredmedia"][0].source_url;
  //   }
  //   return "https://via.placeholder.com/400x200?text=No+Image";
  // }

  if (selectedPost) {
    return (
      <div className="page-root">
        <header className="hero">
          <a className="home-link" href="./" aria-label="Home">
            <svg
              className="home-icon"
              viewBox="0 0 20 20"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
            </svg>
            Home
          </a>

          <div className="hero-content" id="new-claims">
            <h1>Marine Claims & Adjusting</h1>
          </div>
        </header>

        <main className="bg-light-gray">
          <section style={{ padding: "2rem 1rem" }}>
            <div className="max-w-4xl mx-auto">
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <button
                  className="btn-secondary"
                  style={{marginRight: "3rem" }}
                  onClick={function () {
                    setSelectedPost(null);
                  }}
                >
                  Back to Blogs
                </button>
              </div>
              <div style={{ padding: "3rem 6rem" }}>
                <h1
                  style={{
                    fontSize: "2rem",
                    fontWeight: "700",
                    marginBottom: "1rem",
                  }}
                  dangerouslySetInnerHTML={{
                    __html: selectedPost.title.rendered,
                  }}
                ></h1>

                {/* <img
                  src={getImage(selectedPost)}
                  alt="blog"
                  style={{
                    width: "100%",
                    borderRadius: "0.5rem",
                    marginBottom: "2rem",
                  }}
                /> */}

                <div
                  style={{ color: "#334155", lineHeight: "1.8" }}
                  dangerouslySetInnerHTML={{
                    __html: selectedPost.content.rendered,
                  }}
                ></div>
              </div>
            </div>
          </section>
        </main>
      </div>
    );
  }

  return (
    <div className="page-root">
      <header className="hero">
        <a className="home-link" href="./" aria-label="Home">
          <svg
            className="home-icon"
            viewBox="0 0 20 20"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
          </svg>
          Home
        </a>

        <div className="hero-content" id="new-claims">
          <h1>Marine Claims & Adjusting</h1>
        </div>
      </header>

      <main>
        <section
          id="blogs"
          className="bg-light-gray"
          style={{
            paddingTop: "4rem",
            paddingBottom: "4rem",
            marginLeft: "3rem",
            marginRight: "3rem",
          }}
        >
          <div className="max-w-[80rem] mx-auto px-6">
            <h2
              style={{
                fontSize: "1.875rem",
                fontWeight: "700",
                textAlign: "center",
                marginBottom: "1rem",
              }}
            >
              Our Blogs
            </h2>

            <p
              style={{
                fontSize: "1.125rem",
                color: "#475569",
                textAlign: "center",
                maxWidth: "60rem",
                margin: "auto",
                marginBottom: "3rem",
              }}
            >
              Insights, case studies, and expert perspectives from the world of
              marine insurance, claims handling, and maritime law.
            </p>

            {loading ? (
              <p style={{ textAlign: "center" }}>Loading blogs...</p>
            ) : (
              <div className="grid-cols-1-md-3">
                {posts.map(function (post) {
                  return (
                    <article key={post.id} className="service-card">
                      {/* <img
                        src={getImage(post)}
                        alt={post.title.rendered}
                        style={{
                          width: "100%",
                          height: "200px",
                          objectFit: "cover",
                          borderRadius: "0.5rem",
                          marginBottom: "1rem",
                        }}
                      /> */}

                      <h3
                        className="service-card-title"
                        dangerouslySetInnerHTML={{
                          __html: post.title.rendered,
                        }}
                      ></h3>

                      <p
                        style={{ color: "#475569" }}
                        dangerouslySetInnerHTML={{
                          __html:
                            post.excerpt.rendered.substring(0, 150) + "...",
                        }}
                      ></p>

                      <p
                        onClick={function () {
                          setSelectedPost(post);
                        }}
                        style={{
                          marginTop: "1rem",
                          fontWeight: "600",
                          color: "#1d4ed8",
                          cursor: "pointer",
                        }}
                      >
                        Read More →
                      </p>
                    </article>
                  );
                })}
              </div>
            )}
          </div>
        </section>
      </main>
    </div>
  );
}

export default BlogsPage;
